/**
 * Schedule Type RPC Definitions
 */

import { Rpc, RpcGroup } from "effect/rpc";
import { Schema } from "effect";
import {
  ListScheduleTypesRequestSchema,
  ListScheduleTypesResponseSchema,
  FindScheduleTypeRequestSchema,
  FindScheduleTypeResponseSchema,
} from "../schemas/scheduletype/index";
import { ExternalAPIErrorSchema, NotFoundErrorSchema } from "../errors";

export class ScheduleTypeRpcs extends RpcGroup.make(
  Rpc.make("ScheduleTypeList", {
    success: ListScheduleTypesResponseSchema,
    error: Schema.Union([ExternalAPIErrorSchema, NotFoundErrorSchema]),
    payload: ListScheduleTypesRequestSchema,
  }),
  Rpc.make("ScheduleTypeFind", {
    success: FindScheduleTypeResponseSchema,
    error: Schema.Union([ExternalAPIErrorSchema, NotFoundErrorSchema]),
    payload: FindScheduleTypeRequestSchema,
  })
) {}
